export default {
  path: 'register',
  name: 'Register',
  component: () => import(/* webpackChunkName: "Register" */ '@/app/auth/register/RegisterContainer.vue'),
  meta: {
    title: 'TV24 | rejestracja',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
